<template>
  <settings-modal class="payment-assign-modal">
    <template slot="heading">{{ heading }}</template>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-confirm-assignment"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentAssignModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        assignByAmlApiRequest: new ApiRequest(PaymentApi.assignByAml)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      payment () {
        return this.modal.data.payment
      },
      heading () {
        return `Assign payment ${this.payment.id}?`
      },
      loading () {
        return this.assignByAmlApiRequest.loading
      },
      error () {
        return this.assignByAmlApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.assignByAmlApiRequest
          .execute(this.payment.id)
          .then(this.assignByAmlSuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      assignByAmlSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Payment has been successfully assigned.' }
          })
        }, 100)
      }
    }
  }
</script>
